import { render, staticRenderFns } from "./KhoTuanForm.vue?vue&type=template&id=7c0eb238&scoped=true&"
import script from "./KhoTuanForm.vue?vue&type=script&lang=js&"
export * from "./KhoTuanForm.vue?vue&type=script&lang=js&"
import style0 from "./KhoTuanForm.vue?vue&type=style&index=0&id=7c0eb238&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0eb238",
  null
  
)

export default component.exports